import { mapActions, mapState } from 'vuex'
import { debounce } from '@/helpers/debounce'

export default {
  computed: {
    ...mapState('staticMediaStates', ['staticMediaLoading', 'staticMedia']),
  },
  created() {
    if (this.staticMedia.length < 1 && !this.staticMediaLoading) {
      this.getStaticMedia()
    }
  },
  methods: {
    ...mapActions('staticMediaStates', ['getStaticMedia']),
    refetchStaticMedia() {
      debounce(() => this.getStaticMedia(), 500, 'GET_STATIC_MEDIA')
    },
  },
}
